module.exports = __webpack_public_path__ + "img/collection-weddingRingsGayLesbianCouples@2x.9544472.jpg";